// extracted by mini-css-extract-plugin
module.exports = {"possitionLg":"LoginButton_possitionLg__3gFj1","buttonLg":"LoginButton_buttonLg__oxaXQ"};